import { GetAppButton } from 'components/DownloadButton'
import TextBodySmall from 'components/TextBodySmall'
import { View } from 'components/View'
import React from 'react'
import { defineMessages } from 'react-intl'
import formatMessageIntlUtil from 'modules/intl/utils/format-message/index.js'
import useIntl from 'modules/component/utils/hooks/useIntl.js'
import { isInterestedInWorkoutsProfileSelect } from 'modules/profile/redux/selectors/getInterestFocus/index.js'
import useSelector from 'modules/component/utils/hooks/useSelector.js'
import getCurrentTrainingUserSelect from 'modules/training/modules/training-users/selectors/get-current'

const messages = defineMessages({
  installTheApp: {
    id: 'InstallAppForBetterWorkoutExperience.installTheApp',
    defaultMessage: 'Install the Gymaholic App for a better workout experience.'
  },
  installTheAppNutrition: {
    id: 'InstallAppForBetterWorkoutExperience.installTheAppNutrition',
    defaultMessage: 'Install the Gymaholic App to track your meals and macros.'
  }
})

/**
 * @param children
 * @returns {JSX.Element}
 * @constructor
 */
export function InstallAppForBetterWorkoutExperience ({ children }) {
  const intl = useIntl()
  const isInterestedInWorkouts = useSelector(isInterestedInWorkoutsProfileSelect)
  const currentUser = useSelector(getCurrentTrainingUserSelect)

  // Don't show if there's no current user
  if (!currentUser) {
    return null
  }

  let message
  if (!isInterestedInWorkouts) {
    message = messages.installTheAppNutrition
  } else {
    message = messages.installTheApp
  }

  return (
    <View mt>
      <View px={4}>
        <TextBodySmall ta>
          {formatMessageIntlUtil(intl, message)}
        </TextBodySmall>
      </View>

      <View
        mt={0.5}
        style={{
          flexDirection: View.DIRECTION.ROW,
          alignItems: View.ALIGN.CENTER,
          justifyContent: View.JUSTIFY.CENTER
        }}
      >
        <GetAppButton />
        {children}
      </View>
    </View>
  )
}
